import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private modalRef!: NgbModalRef;

  constructor(private modal: NgbModal) {}

  open(modalComponent: any, modalComponentProps?: Record<string, any>, modalOptions?: NgbModalOptions) {
    const options = {
      centered: true,
      scrollable: true,
      ...modalOptions
    };

    this.modalRef = this.modal.open(modalComponent, options);
    if (modalComponentProps) {
      Object.keys(modalComponentProps).forEach((key) => {
        this.modalRef.componentInstance[key] = modalComponentProps[key];
      });
    }
    return this.modalRef;
  }

  close(result?: any) {
    if (this.modalRef) {
      this.modalRef.close(result);
    }
    return true;
  }
}
